import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ProgressService} from "./progress.service";

declare var ENVIRONMENT_CONFIG: any;

@Injectable()
export class AppDetailsService {

    constructor(
        private http: HttpClient,
        private progressService: ProgressService
    ) {}

    getFundraisingToolsAppDetails() {
        this.progressService.startProgress(false);
        return this.http.get(ENVIRONMENT_CONFIG.apiUrl + '/api/v1/app', {});
    }

    getLogicalAPIAppDetails() {
        this.progressService.startProgress(false);
        return this.http.get(ENVIRONMENT_CONFIG.graphqlUrl + '/logical/api/v1/app', {});
    }

}
